import {useField} from "formik";
import MuiPhoneNumber from "material-ui-phone-number";
import React from "react";

export function PhoneNumber(props) {
    const [field, meta, helpers] = useField(props);

    const onChange = (value) => {
        helpers.setValue(value);
    }
    const onBlur = () => {
        helpers.setTouched(true);
    }

    return (
        <MuiPhoneNumber
            autoComplete={"new-password"}
            label={props.label}
            value={field.value}
            required
            fullWidth
            defaultCountry={props.defaultCountry}
            disableAreaCodes
            //disableCountryCode
            //disableDropdown
            //autoFormat={false}
            onChange={onChange}
            onBlur={onBlur}
            margin={"normal"}
            variant="outlined"
            error={meta.touched && !!meta.error}
            helperText={
                meta.touched && meta.error
            }
        />
    );
}
